export class Times {
  public static get SEC(): number {
    return 1000;
  }

  public static get MIN(): number {
    return this.SEC * 60;
  }

  public static get HOUR(): number {
    return this.MIN * 60;
  }

  public static get DAY(): number {
    return this.HOUR * 24;
  }

  public static get YEAR(): number {
    return this.DAY * 365;
  }

  public static get SUFFIXS(): string[] {
    return ['y', 'd', 'h', 'm', 's'];
  }

  public static toString(time: number, type: string = "ms", limit: number = 0, suffixs: string[] = null): string {
    const a: Array<string> = [];
    const s: string[] = suffixs ? suffixs : this.SUFFIXS;

    const value = type == 'ms' ? time : time * 1000;

    if (!value || value <= 0) return '0' + (type == 'ms' ? s[4] : s[5]);

    if (time >= this.YEAR) {
      a.push(Math.floor(time / this.YEAR) + s[0]);
      time = time % this.YEAR;
    }

    if (time >= this.DAY) {
      a.push(Math.floor(time / this.DAY) + s[1]);
      time = time % this.DAY;
    }

    if (time >= this.HOUR) {
      a.push(Math.floor(time / this.HOUR) + s[2]);
      time = time % this.HOUR;
    }

    if (time >= this.MIN) {
      a.push(Math.floor(time / this.MIN) + s[3]);
      time = time % this.MIN;
    }

    a.push(Number((time / this.SEC).toFixed(2)) + s[4]);

    if (a.length === 0) return '0' + s[4];
    else if (limit > 0 && a.length > limit) a.length = limit;

    return a.join(' ');
  }
}